import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams } from "react-router-dom";

/* 🔒 FORCE SAFE TEXT WRAPPING FOR QUILL CONTcENT */
const articleWrapStyle = {
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};

const CustomerResearchDetails = () => {
  const { id } = useParams();
  const [paper, setPaper] = useState(null);

  useEffect(() => {
    fetchPaper();
  }, []);

  const fetchPaper = async () => {
    try {
      const res = await api.get(`/api/research-papers/${id}`);
      setPaper(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  if (!paper) return <p>Loading...</p>;

  const sections = JSON.parse(paper.sectionsJson || "[]");
  const researchers = JSON.parse(paper.researchersJson || "[]");

  return (
    <div className="container mt-4">
      <h2>{paper.title}</h2>

      {/* 🔹 POSTED BY INFO */}
      <div
        style={{
          background: "#f8f9fa",
          padding: "10px",
          borderRadius: "6px",
          marginBottom: "15px",
          border: "1px solid #ddd",
        }}
      >
        <p className="mb-1">
          <b>Posted By:</b> {paper.postedByEmail}
        </p>
        <p className="mb-0">
          <b>User Type:</b>{" "}
          <span style={{ fontWeight: "bold", color: "#0d6efd" }}>
            {paper.postedByType}
          </span>
        </p>
      </div>

      {/* 🔹 ABSTRACT */}
      <h4>Abstract</h4>
      <div
        style={articleWrapStyle}
        dangerouslySetInnerHTML={{ __html: paper.abstractText }}
      />

      {/* 🔹 KEYWORDS */}
      <p>
        <b>Keywords:</b> {paper.keywords}
      </p>

      {/* 🔹 RESEARCHERS */}
      <h4>Researchers</h4>
      <ul>
        {researchers.map((r, i) => (
          <li key={i}>
            {r.name} — {r.qualification}
          </li>
        ))}
      </ul>

      {/* 🔹 SECTIONS */}
      <h4>Sections</h4>
      {sections.map((s, i) => (
        <div key={i} className="mb-3">
          <h5>{s.heading}</h5>
          <div
            style={articleWrapStyle}
            dangerouslySetInnerHTML={{ __html: s.content }}
          />
        </div>
      ))}

      {/* 🔹 STATUS */}
      <p>
        <b>Status:</b>{" "}
        <span style={{ color: paper.status === "APPROVED" ? "green" : "red" }}>
          {paper.status}
        </span>
      </p>
    </div>
  );
};

export default CustomerResearchDetails;
